<template>
    <div class="comment-card">
        <div class="comment-card-content">
            <div class="icon">
                <img src="@/assets/tcm-portal/comment-user-avatar/icon.png" />
            </div>
            <span>{{ planItem.content }}</span>
            <div class="border-div"></div>
        </div>
        <div class="student-info-container">
            <div class="student-img">
                <img :src="avatarImg" />
            </div>
            <div class="student-name">{{ planItem.userName }}</div>
            <div class="student-info">{{ planItem.userFrom }}</div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
    name: "comment-card",
    props: {
        index: {
            type: Number,
            default: 1
        },
        planItem: {
            type: Object
        }
    },
    data() {
        return {
            avatarImg: require(`@/assets/tcm-portal/comment-user-avatar/avatar-${this.index + 1}.png`)
        };
    }
});
</script>

<style scoped lang="less">
.comment-card {
    margin-top: 16px;
    background-color: #fff;
    border-radius: 24px 0 24px 24px;
    .comment-card-content {
        margin: 0 20px;
        border-radius: 24px 0 24px 24px;
        background-color: #1869b8;
        padding: 16px 16px 32px;
        position: relative;
        .icon {
            display: flex;
            justify-content: center;
            width: 100%;
            margin-bottom: 10px;
            img {
                height: 24px;
                width: 24px;
            }
        }
        span {
            color: #fff;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 21px;
        }
        .border-div {
            width: calc(100% - 2px);
            border-left: 1px solid rgba(42, 42, 42, 0.15);
            border-right: 1px solid rgba(42, 42, 42, 0.15);
            position: absolute;
            margin-left: -16px;
            height: 32px;
        }
    }
    .student-info-container {
        margin: 0 20px;
        padding: 0 16px 16px 16px;
        display: flex;
        align-items: center;
        flex-direction: column;
        border-radius: 0 0 24px 24px;
        border-bottom: 1px solid rgba(42, 42, 42, 0.15);
        border-left: 1px solid rgba(42, 42, 42, 0.15);
        border-right: 1px solid rgba(42, 42, 42, 0.15);
        .student-img {
            width: 70px;
            height: 70px;
            border-radius: 70px;
            position: absolute;
            margin-top: -32px;
        }
        .student-name {
            margin-top: 40px;
            color: #262833;
            font-size: 18px;
            font-style: normal;
            font-weight: 600;
            line-height: 27px;
        }
        .student-info {
            color: #70748c;
            text-align: center;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
        }
    }
}
</style>
